import React from 'react';

// Renders the maker-supplied review link (relative path or http(s) URL) opened
// safely in a new tab. Returns null when no link was provided.
export default ({
  uri,
  className = 'btn btn-sm btn-outline-primary',
  label = 'View resource',
}) => {
  if (!uri) return null;
  return (
    <a
      href={uri}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      title={uri}
    >
      {label} <span aria-hidden="true">↗</span>
    </a>
  );
};
